'use client'

import Image from 'next/image'
import { useEffect, useRef } from 'react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css'

const swiperData = [
    {
        id: 1,
        content_heading: 'Freecast ',
        content_text:
            'They delivered an exceptional OTT application, showcasing technical expertise and customer-centricity. Their deep understanding of OTT technology, seamless integration of trends and reliable functionality exceeded expectations. I wholeheartedly recommend their services.',
        user_name: 'William A. Mobley, Jr.',
        company_name: 'Freecast',
        logo: '/Home/l9.png',
    },
    {
        id: 2,
        content_heading: 'Bleachsecurity',
        content_text:
            'Bleachsecurity delivers next-generation cybersecurity solutions, protecting businesses against evolving threats with advanced monitoring, automation and AI-driven threat intelligence.',
        user_name: 'Sarah Williams',
        company_name: 'Bleachsecurity',
        logo: '/Home/l2.png',
    },
    {
        id: 3,
        content_heading: 'ICSI - India',
        content_text:
            'Cloudastra Technologies develops digital education solutions that have transformed professional training at ICSI (Institute of Company Secretaries of India). Their platform improves the learning experience and resource accessibility for company secretary students while making administrative processes more efficient.',
        user_name: 'Rohan Mehta',
        company_name: 'ICSI',
        logo: '/Home/l17.png',
    },
    {
        id: 4,
        content_heading: 'Altcase - Global',
        content_text:
            'Altcase empowers global investors with innovative fintech solutions, simplifying portfolio management, providing real-time analytics and enabling data-driven decision-making.',
        user_name: 'Madhusudhan ML',
        company_name: 'Altcase',
        logo: '/Home/l4.png',
    },
    {
        id: 5,
        content_heading: 'Politech ',
        content_text:
            'They revolutionized our insurance services with an AI-based bot, streamlining customer interactions and significantly reducing costs. Their tailored solution efficiently handles claims, improving operational efficiency and enhancing the overall customer experience.',
        user_name: 'Corey Kuwanoe',
        company_name: 'Politech',
        logo: '/Home/l20.png',
    },
    {
        id: 6,
        content_heading: 'MHP ',
        content_text:
            'Cloudastra Technologies has elevated home interiors with their AI-based application, predicting ideal designs. Their innovative tool streamlined decision-making, adding a delightful, creative dimension to home transformations, enhancing personalization for an unparalleled experience.',
        user_name: 'Castleigh Johnson',
        company_name: 'MHP',
        logo: '/Home/l14.png',
    },
    {
        id: 8,
        content_heading: 'Tompkins',
        content_text:
            "Cloudastra's Nigmat Bot revolutionized our B2B operations with next-gen AI technology. Its versatility and cost savings were remarkable. The beta version, handled with dedication, showcased Cloudastra's commitment to client success.",
        user_name: 'Mike Futch',
        company_name: 'Tompkins',
        logo: '/Home/tk.png',
    },
]

const Reviews = () => {
    const swiperRef = useRef(null)

    useEffect(() => {
        return () => {
            if (swiperRef.current && !swiperRef.current.destroyed) {
                swiperRef.current.autoplay?.stop()
                swiperRef.current.destroy(true, false)
            }
        }
    }, [])

    return (
    <>
        <div className='mx-auto my-12 max-w-[900px]'>
            {/* Small Intro Text */}
            
            <br />

            {/* Main Heading */}
            <div className='md:text-center'>
                <h2 className='font-inter mt-2 text-3xl font-bold leading-snug text-[#172554] md:text-5xl'>
                    Hear from Our Happy Customers
                </h2>

                {/* Supporting Paragraph */}
                <p className='mt-4 text-[16px] text-[#051114] opacity-80 md:text-[18px]'>
                    We value every client we work with. Explore their stories and learn how our
                    solutions helped them save time, boost efficiency and achieve their goals.
                </p>

                {/* Decorative Line (Optional) */}
                <div className='mx-auto mt-6 h-1 w-16 rounded-full bg-blue-600 md:text-center'></div>
            </div>
        </div>

        <div className='relative'>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}
                pagination={{ clickable: true }}
                breakpoints={{
                    650: { slidesPerView: 2, spaceBetween: 40 },
                    1050: { slidesPerView: 3, spaceBetween: 50 },
                }}
                modules={[Pagination, Autoplay]}
                loop
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                onSwiper={(swiper) => { swiperRef.current = swiper }}>
                {swiperData.map((data) => (
                    <SwiperSlide key={data.id} className='!h-auto self-stretch py-6'>
                        <div className='flex h-full flex-col justify-between rounded-2xl border border-gray-100 bg-white p-6 shadow-md transition-shadow'>
                            {/* Review Content */}
                            <div className='flex-1'>
                                <svg
                                    className='mb-3 h-6 w-6 text-gray-300'
                                    viewBox='0 0 24 24'
                                    fill='currentColor'
                                    aria-hidden='true'>
                                    <path d='M7.17 6.17C8.72 4.62 10.62 4 12.88 4v3.14c-1.26 0-2.29.42-3.08 1.25-.79.83-1.18 1.88-1.18 3.14h3.14V20H4v-7.47c0-2.43.86-4.45 2.57-6.16Zm9.76 0C18.49 4.62 20.39 4 22.65 4v3.14c-1.26 0-2.29.42-3.08 1.25-.79.83-1.18 1.88-1.18 3.14h3.14V20H13.8v-7.47c0-2.43.86-4.45 2.57-6.16Z' />
                                </svg>
                                <p className='mb-2 text-lg font-semibold text-gray-900'>
                                    {data.content_heading}
                                </p>
                                <p className='line-clamp-[6] text-[15px] leading-6 text-gray-700'>
                                    {data.content_text}
                                </p>
                            </div>

                            {/* User Row */}
                            <div className='mt-6 flex items-center gap-4 border-t border-gray-200 pt-4'>
                                <div className='relative flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full border border-gray-400 p-1 shadow-lg shadow-gray-300'>
                                    <Image
                                        src={data.logo}
                                        alt={data.company_name}
                                        width={60}
                                        height={60}
                                        className='object-contain'
                                    />
                                </div>
                                <div className='min-w-0'>
                                    <div className='truncate text-lg font-semibold text-gray-900'>
                                        {data.user_name}
                                    </div>
                                    <div className='truncate text-sm text-gray-500'>
                                        @{data.company_name}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    </>
    )
}

export default Reviews
